<template>
<div class="chapter">
<div class="inner_page">
<p class="left"><a id="pvi"></a> Copyright © 2006 by Rita Williams</p>
<p class="left">All rights reserved. No part of this publication may be reproduced<br/>
or transmitted in any form or by any means, electronic or mechanical,<br/>
including photocopy, recording, or any information storage and<br/>
retrieval system, without permission in writing from the publisher.</p>
<p class="left">Requests for permission to make copies of any part of the work<br/>
should be mailed to the following address: Permissions Department,<br/>
Harcourt, Inc., 6277 Sea Harbor Drive, Orlando, Florida 32887-6777.</p>
<p class="left"><a href="http://www.HarcourtBooks.com" target="_blank">www.HarcourtBooks.com</a></p>
<p class="left">The Library of Congress has cataloged the hardcover edition as follows:<br/>
Williams, Rita (Rita Ann)<br/>
If the creek don't rise: my life out West with the last Black<br/>
widow of the Civil War/Rita Williams.—1st ed.<br/>
p. cm.</p>
<p class="left">1. Williams, Rita (Rita Ann) 2. African American<br/>
women—Biography. 3. African Americans—Biography.<br/>
4. Colorado—Biography. I. Title.<br/>
E185.97.W73A3 2006<br/>
978.8'00496073092—dc22 2006000335<br/>
ISBN 978-0-15-101154-4<br/>
ISBN 978-0-15-603285-8 (pbk.)</p>
<p class="left">Text set in Fournier<br/>
Designed by Cathy Riggs</p>
<p class="left">Printed in the United States of America</p>
<p class="left">First Harvest edition 2007<br/>
<span style="font-size: smaller">K J I H G F E D C B A</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?19f4fe43